// Store + socket compartidos. Extraídos de index.js para que módulos
// (servicios, lib entry) puedan importar el store SIN disparar el
// ReactDOM.render del bootstrap standalone (que vive en index.js).
import SignalRSocket from './components/SignalrSocket';
import { configureStore } from './redux/store';

export const socket = new SignalRSocket();
export const store = configureStore(undefined, socket);
